<template>
    <div class="container">

        <div class="row">
            <div class="col-md-12 mt-2 mb-3">
                <h1>
                    <span v-if="editMode">Urejanje evidene dopusta</span>
                    <span v-if="!editMode">Dodajanje zapisa v evidenco dopusta</span>
                </h1>
            </div>
        </div>

        <div class="row">
            <div class="col-md-12">

                <!--                {{project}}-->
                <!--                <br/><br/>-->
<!--                {{vacationDaysReport}}-->


                <b-form-group
                        label="Izberi leto"
                        label-for="date">

                    <v-select
                            v-model="vacationDaysReport.year"
                            placeholder="leto"
                            id="year"
                            name="month"
                            label="name"
                            :reduce="item => item.id"
                            :options="[
                                {id: 2018, name: '2018'},
                                {id: 2019, name: '2019'},
                                {id: 2020, name: '2020'},
                                {id: 2021, name: '2021'},
                                {id: 2022, name: '2022'},
                                {id: 2023, name: '2023'},
                                {id: 2024, name: '2024'},
                                {id: 2025, name: '2025'},
                                {id: 2026, name: '2026'},
                            ]"
                            :disabled="readonly"
                    >

                        <span slot="no-options">Ni zadetkov.</span>

                    </v-select>

                </b-form-group>

                <b-form-group id="selectedUser"
                              label="Oseba"
                              label-for="selectedUser">

                    <v-select
                            v-model="vacationDaysReport.userId"
                            id="selectedUser"
                            name="selectedUser"
                            label="last_name"
                            :options="users"
                            :disabled="readonly"
                            :reduce="item => item.id"
                    >
                        <span slot="no-options">Ni zadetkov.</span>

                        <template slot="option" slot-scope="item">
                            {{ getOptionLabel(item) }}
                        </template>

                        <template slot="selected-option" slot-scope="item">
                            {{ getOptionLabel(item) }}
                        </template>


                    </v-select>
                </b-form-group>

                <b-form-group
                        id="daysTotal"
                        label="Število dni pripadajočega dopusta"
                        label-for="daysTotal">
                    <b-form-input id="daysTotal" v-model="vacationDaysReport.daysTotal"
                                  placeholder="število dni dopusta na voljo" trim
                                  :disabled="readonly"
                                  type="number"></b-form-input>
                </b-form-group>

                <!-- Fields removed as they're now calculated in WorkHoursReport.vue -->


            </div>
        </div>
        <div class="row">
            <div class="col-md-12 mt-3">
                <div class="d-flex">
                    <button v-if="editMode" class="btn btn-danger mr-auto" @click="deleteWorkHoursReportConfirmation()">
                        <i class="fa fa-trash"></i>
                        Izbriši
                    </button>

                    <button v-if="!editMode" type="submit" @click="addVacationDaysReport()" class="btn btn-info ml-auto"><i
                            class="fa fa-save"></i> Shrani podatke
                    </button>


                    <button v-if="editMode" type="submit" @click="updateVacationDaysReport()" class="btn btn-info ml-auto">
                        <i
                                class="fa fa-save"></i> Posodobi podatke
                    </button>
                </div>

                <div>

                    <router-link :to="{ name: 'AdminVacationDaysReport'}" class="btn btn-link pt-4">
                        Prekliči
                    </router-link>

                </div>
            </div>
        </div>

    </div>
</template>

<script>
    import firebase from 'firebase'
    import {db} from '../../main'
    import vSelect from 'vue-select'
    import 'vue-select/dist/vue-select.css'

    export default {
        name: 'EditProject',
        components: {
            vSelect
        },
        data() {
            return {
                users: this.$store.getters.getUsers,
                vacationDaysReport: {
                    createdAt: null,
                    daysTotal: null,
                    id: "",
                    updatedAt: null,
                    userId: "",
                    year: null
                },
                id: this.$route.params.id,
                readonly: this.$route.params.readonly,
                editMode: false
            }
        },
        // firestore () {
        //   if (this.id) {
        //     return {
        //       vacationDaysReport: db.collection('vacationDaysReports').doc(this.id),
        //     }
        //   } else {
        //     return {
        //     }
        //   }
        // },
        mounted() {
            const _this = this;

            if (_this.$store.getters.getUsers.length === 0) {
                _this.$store.dispatch('retrieveUsers').then(() => {
                    _this.users = _this.$store.getters.getUsers

                })
            }

            if (_this.id) {
                _this.editMode = true
                _this.retrieveVacationDaysReport();
            } else {
                _this.editMode = false
                // Initialize with current year as default
                _this.vacationDaysReport.year = new Date().getFullYear();
                // Default to 30 days
                _this.vacationDaysReport.daysTotal = 30;
                // Don't set userId - let the admin select the user
            }

            console.log("vacationDaysReport ->", this.vacationDaysReport);

        },
        methods: {
            getOptionLabel (option) {
                //console.log(option);
                return this.getReadableUser(option.id)
            },

            retrieveVacationDaysReport() {
                const _this = this

                db.collection('vacationDaysReports')
                    .doc(this.id)
                    .get()
                    .then(snapshot => {
                        const document = snapshot.data()

                        // _.forOwn(document, function (value, key) {
                        //     if (key === 'date') {
                        //         document[key] = _this.moment.unix(value.seconds).format('YYYY-MM-DDTHH:mm:ssZ')
                        //     } else if (key === 'startTime' || key === 'endTime') {
                        //         document[key] = _this.moment.unix(value.seconds).format('HH:mm')
                        //     }
                        // })

                        _this.vacationDaysReport = document;

                        console.log(document);

                    })
            },

            updateVacationDaysReport(id) {
                const _this = this
                const currentWorkHoursReport = db.collection('vacationDaysReports').doc(this.id)


                return currentWorkHoursReport.update({
                    createdAt: _this.vacationDaysReport.createdAt,
                    daysTotal: _this.vacationDaysReport.daysTotal,
                    updatedAt: new Date(),
                    userId: _this.vacationDaysReport.userId,
                    year: _this.vacationDaysReport.year
                })
                    .then(function () {
                        _this.$router.push({ name: 'AdminVacationDaysReport'});
                    })
                    .catch(function (error) {
                        // The document probably doesn't exist.
                        console.error('Error updating work hour report: ', error)
                    })

            },

            addVacationDaysReport() {
                const _this = this
                
                // Validate required fields
                if (!_this.vacationDaysReport.userId) {
                    _this.$swal('Manjkajoči podatki', 'Izberite osebo za dodelitev dopusta!', 'error', {dangerMode: true});
                    return;
                }
                
                if (!_this.vacationDaysReport.year) {
                    _this.$swal('Manjkajoči podatki', 'Izberite leto za dodelitev dopusta!', 'error', {dangerMode: true});
                    return;
                }
                
                if (!_this.vacationDaysReport.daysTotal || _this.vacationDaysReport.daysTotal <= 0) {
                    _this.$swal('Manjkajoči podatki', 'Vnesite veljavno število dni dopusta!', 'error', {dangerMode: true});
                    return;
                }

                let ref = db.collection('vacationDaysReports').doc()
                ref.set({id: ref.id}) // set new document ID
                    .then(() => {  // fetch the doc again and show its data
                        ref.get().then(doc => {
                            _this.id = doc.data().id
                            _this.vacationDaysReport.createdAt = new Date()
                            // Don't override the selected user with the admin user
                            // Make sure a user is selected before saving
                            if (!_this.vacationDaysReport.userId) {
                                // If no user selected, show error
                                _this.$swal('Manjkajoči podatki', 'Izberite osebo za dodelitev dopusta!', 'error', {dangerMode: true});
                                return;
                            }
                            _this.updateVacationDaysReport()
                        })
                    })
            },
            deleteWorkHoursReportConfirmation() {
                const _this = this

                this.$swal({
                    title: 'Opozorilo',
                    text: 'Ali ste prepričani, da želite izbrisati projekt ' + _this.project.name + '? Po potrditvi izbire ne bo več mogoče preklicati.',
                    dangerMode: true,
                    buttons: {
                        cancel: {
                            text: 'Prekliči',
                            value: null,
                            visible: true,
                            className: '',
                            closeModal: true,
                        },
                        confirm: {
                            text: 'Izbriši',
                            value: true,
                            visible: true,
                            className: '',
                            closeModal: true
                        }
                    },
                })
                    .then((value) => {

                        switch (value) {

                            case true:

                                _this.deleteWorkHoursReport()

                            case null:

                                return

                                break

                            default:

                        }
                    })
            },
            deleteWorkHoursReport() {
                const _this = this

                db.collection('vacationDaysReports').doc(_this.id).delete()
                    .then(function () {
                        _this.$router.push({name: 'AdminVacationDaysReport'});
                    })
                    .catch(function (error) {
                        // The document probably doesn't exist.
                        console.error('Error deleting work hour report: ', error)
                    })
            },
            calculateDuration() {
                const _this = this

                let startTime = _this.moment(_this.vacationDaysReport.startTime, 'HH:mm');
                let endTime = _this.moment(_this.vacationDaysReport.endTime, 'HH:mm');

                _this.vacationDaysReport.endTime = endTime;
                _this.vacationDaysReport.startTime = startTime;

                console.log("startTime ", startTime);
                console.log("endTime ", endTime);

                _this.vacationDaysReport.duration = _this.moment.duration(_this.moment(endTime).diff(_this.moment(startTime))).format('HH:mm'), 'hours';

                //_this.duration = _this.moment.duration(_this.endTime.diff(_this.startTime));
                //console.log(_this.moment.duration(_this.moment(_this.vacationDaysReport.endTime, 'YYYY-MM-DDTHH:mm:ssZ').diff(_this.moment(_this.vacationDaysReport.startTime, 'YYYY-MM-DDTHH:mm:ssZ'))).asHours());

            },
            getReadableUser (userId) {
                const _this = this

                let userObj = _.filter(_this.users, {'id': userId})[0]
                if (userObj) {
                    return userObj.first_name + ' ' + userObj.last_name
                } else {
                    return 'n/a'
                }
            },
        }
    }
</script>



// WEBPACK FOOTER //
// src/pages/admin/EditVacationDaysReport.vue